@if (!!questions) {
  <div class="replace-vehicle main">
    @if (hasError | async) {
      <div class="pad-20 error-600-text caption">{{ errorMessage }}</div>
    }
    <div class="row">
      <div class="column twelve">
        <form [formGroup]="underWritingQuestionsForm" (ngSubmit)="answersSubmit()">
          <div>
            <div class="row pad-bottom-10">
              <fieldset>
                @for (question of questions; track question) {
                  <ds-underwriting-question
                    [questionObject]="question"
                    [underWritingQuestionsForm]="underWritingQuestionsForm"
                    (answerSelectedEvent)="answerSelected($event)"
                  ></ds-underwriting-question>
                }
                @if (showTPIQuestion) {
                  <ds-underwriting-question
                    [questionObject]="tpiQuestion"
                    [underWritingQuestionsForm]="underWritingQuestionsForm"
                  >
                  </ds-underwriting-question>
                }
              </fieldset>
            </div>
          </div>
          <div class="row callToAction">
            <span class="md-float-right">
              <a
                class="pad-horizontal-20"
                (click)="cancel()"
                dsContent
                [contentPath]="'shared.cancel'"
              ></a>
              <button
                ds-button
                type="submit"
                [disabled]="underWritingQuestionsForm?.invalid"
                data-cy="replaceVehicleUnderwritingQuestionNextButton"
              >
                Next
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
}
